<template>
  <div>
    <v-container>
      <v-row align="end">
        <v-col cols="10">
          <k-card-header title="Product Mappings" :items="headerItems"></k-card-header>
        </v-col>
		<v-col cols="2" class="text-right" >
			<v-switch v-model="showFilter" dense hide-details label="Show Filter" class="mr-0 pr-0" ref="filterToggle"/>
		</v-col>
      </v-row>

		<v-slide-y-transition>
		<v-row v-if="showFilter" ref="filterRow">
			<v-col cols="12">
					<v-card>
						<v-card-text>
							<v-container>
								<v-row>
									<v-col cols="5">
										<h3>Account Type</h3>
									</v-col>
									<v-col cols="7">
										<h3>Kasasa Powered</h3>
									</v-col>
								</v-row>

								<v-row class="mt-0 pt-0">
									<v-col cols="5">
										<v-checkbox
											v-model="tableFilter.accountTypes"
											label="DDA"
											value="DDA"
											dense
											hide-details
											ref="ddaFilter"
											class="d-inline-block"
										/>

										<v-checkbox
											v-model="tableFilter.accountTypes"
											label="SAV"
											value="SAV"
											dense
											hide-details
											ref="savFilter"
											class="d-inline-block ml-5"
										/>


										<v-checkbox
											v-model="tableFilter.accountTypes"
											label="CD"
											value="CD"
											dense
											hide-details
											ref="cdFilter"
											class="d-inline-block ml-5"
										/>

										<v-checkbox
											v-model="tableFilter.accountTypes"
											label="LOAN"
											value="LOAN"
											dense
											hide-details
											ref="loanFilter"
											class="d-inline-block ml-5"
										/>

										<v-checkbox
											v-model="tableFilter.accountTypes"
											label="MMDA"
											value="MMDA"
											dense
											hide-details
											ref="mmdaFilter"
											class="d-inline-block ml-5"
										/>
									</v-col>


									<v-col cols="3">
										<v-radio-group dense hide-details row class="mt-0" v-model="tableFilter.kasasaPowered">
											<v-radio label="Yes" :value="KasasaPoweredState.YES" ref="kasasaPoweredYesButton"/>
											<v-radio label="No" :value="KasasaPoweredState.NO" ref="kasasaPoweredNoButton"/>
											<v-radio label="Both" :value="KasasaPoweredState.BOTH" ref="kasasaPoweredBothButton"/>
										</v-radio-group>
									</v-col>

									<v-col cols="3" class="text-right">
										<v-btn color="primary" @click="applyFilter()" ref="applyButton">Apply</v-btn>
										<v-btn class="ml-5" @click="clearFilter()" ref="clearButton">Clear</v-btn>
									</v-col>
								</v-row>
							</v-container>

						</v-card-text>
					</v-card>
			</v-col>
		</v-row>
		</v-slide-y-transition>

		<v-row v-if="productMappingErrorMessage">
			<v-col cols="12">
				<v-alert ref="verificationAlert" type="error">{{productMappingErrorMessage}} <v-btn class="ml-4" ref="downloadErrorReportButton" text @click="downloadErrorReport" :loading="downloadingErrorReport">Download Report</v-btn></v-alert>
			</v-col>
		</v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="detailCard">
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="filteredProductMappings"
                :loading="loading > 0"
                :footer-props="footerProps"
                :hide-default-footer="false"
          		item-key="id"
                ref="productMappingTable"
                @current-items="onVisibleItemsChanged">

                <template v-slot:item="{ item, index }">
                  <tr @click.exact="rowClick(item, index)" @click.ctrl.exact="ctrlClick(item, index)"
                    @click.meta.exact="ctrlClick(item, index)" @click.shift.exact="shiftClick(item, index)"
                    :class='getRowClassForItem(item)'>
                    <td><product-mapping-dialog
							:smallButton="true"
							:mapping="item.mapping"
							:productTypeMap="productTypes"
							:coreAccountTypeMap="coreAccountTypeMap"
							:accountProductTypeMap="accountProductTypeMap"
							@success="onMappingSaved"/></td>
                    <td>{{ item.mapping.accountType }}</td>
                    <td>
                      <v-container>
                        <v-row v-for="productType in item.mapping.coreAccountProductTypes" v-bind:key="productType.id">
                          {{productType.coreAccountType}}
                        </v-row>
                      </v-container>
                    </td>
                    <td>
                      <v-container>
                        <v-row v-for="productType in item.mapping.coreAccountProductTypes" v-bind:key="productType.id">
                          {{productType.coreProductCode}}
                        </v-row>
                      </v-container>
                    </td>
                    <td>{{ getFriendlyProductTypeName(item.mapping.productType) }}</td>
                    <td>{{ item.mapping.kasasaBranded ? "Yes" : "No" }}</td>
                    <td>{{ item.mapping.fiProductName }}</td>
                    <td>{{ item.mapping.externalProductMappingId }}</td>
                    <td>{{ getLastQueryCount(item) }}</td>
                    <td>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn icon text v-on="on">
                            <v-icon>fa-ellipsis-v</v-icon>
                          </v-btn>
                        </template>
                        <v-list v-if="selectedMappings.has(item) && selectedMappings.size > 1" id='multiselectmenu'>
                          <v-list-item @click="onMergeSelectedMappings()">
                            <v-list-item-title>Merge {{selectedMappings.size}} Mappings</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="onDeleteSelectedMappings()">
                            <v-list-item-title>Delete {{selectedMappings.size}} Mappings</v-list-item-title>
                          </v-list-item>
                        </v-list>
                        <v-list v-else>
                          <v-list-item @click="onDeleteSingleMapping(item)" id='singleselectmenu'>
                            <v-list-item-title>Delete Mapping</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
				</template>
              </v-data-table>
            </v-card-text>
			<v-card-actions v-if="loading == 0">
				<v-row class="mt-0 pt-0 mb-1 ml-2">
					<v-col>
						<product-mapping-dialog
							:productTypeMap="productTypes"
							:coreAccountTypeMap="coreAccountTypeMap"
							:accountProductTypeMap="accountProductTypeMap"
							@success="onMappingSaved"/>

						<v-btn color="info" class="ml-4 mb-2" dark @click="exportProductMappings()" ref="exportButton" :loading="exporting"><v-icon class="pr-1">fa-download</v-icon>Create Product Mapping Excel</v-btn>

						<v-btn color="info" class="ml-4 mb-2" dark @click="$refs.uploader.click()" ref="uploadButton" :loading="uploading"><v-icon class="pr-1">fa-upload</v-icon>Upload Product Mappings</v-btn>

						<input
							ref="uploader"
							class="d-none"
							type="file"
							accept=".xls,.xlsx"
							@change="onFileChanged"
						>
						<v-btn ref="verifyButton" color="info" class="ml-4 mb-2" dark @click="verify()" :loading="verifying"><v-icon class="pr-1">fa-check</v-icon>Verify</v-btn>
					</v-col>

				</v-row>
			</v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Mutation } from 'vuex-class';
import { AxiosResponse } from 'axios';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import { DataTableHeader } from 'vuetify';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import {
  ProductMappingResource, ProductMapping, CoreAccountProduct, VerificationResponse,
} from '@/api/productmapping';
import {
  ProductTypesResource, ProductTypeMap,
} from '@/api/producttypes';
import {
  AccountProductTypesResource, AccountProductTypeMap,
} from '@/api/accountproducttypes';
import { AccountTypeMappingRuleResource, AccountTypeMappingRule }
  from '@/api/accounttypes/';
import ProductMappingDialog from '@/components/ProductMappingDialog.vue';

interface ProductMappingTableEntry {
	mapping: ProductMapping,
	selected: boolean,
}

enum KasasaPoweredState {
	YES, NO, BOTH
}

interface TableFilter {
	accountTypes: string[],
	kasasaPowered: KasasaPoweredState,
}


@Component({
  computed: mapState(['fiId', 'productMappingErrorMessage']),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    ProductMappingDialog,
  },
})
export default class ProductMappings extends Vue {
  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'Product Mappings',
      disabled: true,
    },
  ];

  fiId!: number;

  loading: number = 0;

  exporting: boolean = false;

  uploading: boolean = false;

  verifying: boolean = false;

  downloadingErrorReport:boolean = false;

 	footerProps: any = {
	  'items-per-page-options': [{ value: -1, text: 'All' }, 25, 50, 100],
 	}


  headers: DataTableHeader[] = [
    {
      text: '', value: 'edit', align: 'start', sortable: false,
    },
    {
      text: 'Account Type', value: 'mapping.accountType', align: 'start', sortable: true,
    },
    {
      text: 'Core Account Type', value: '', align: 'start', sortable: false,
    },
    {
      text: 'Core Product Code', value: '', align: 'start', sortable: false,
    },
    {
      text: 'Product Type', value: 'mapping.productType', align: 'start', sortable: true,
    },
    {
      text: 'Kasasa Branded', value: 'mapping.kasasaBranded', align: 'start', sortable: true,
    },
    {
      text: 'FI Product Name', value: 'mapping.fiProductName', align: 'start', sortable: true,
    },
    {
      text: 'ID', value: 'mapping.externalProductMappingId', align: 'start', sortable: true,
    },
    {
      text: 'Last Query Count', value: 'mapping.lastQueryCount', align: 'start', sortable: true,
    },
    {
      text: '', value: '', align: 'start', sortable: false,
    },
  ];

	@Inject('ProductMappingResource')
	productMappingResource!: ProductMappingResource;

	@Inject('ProductTypesResource')
	productTypesResource!: ProductTypesResource;

	@Inject('AccountProductTypesResource')
	accounProductTypesResource!: AccountProductTypesResource;

	@Inject('AccountTypeMappingRuleResource')
    accountTypeMappingRuleResource!:AccountTypeMappingRuleResource;

	productTypes: ProductTypeMap | null = null;

	coreAccountTypeMap:Map<string, string[]> = new Map<string, string[]>();

	accountProductTypeMap:AccountProductTypeMap = {};

	allProductMappings: ProductMappingTableEntry[] = [];

	filteredProductMappings: ProductMappingTableEntry[] = [];

	selectedMappings:Set<ProductMappingTableEntry> = new Set<ProductMappingTableEntry>();

	// Shift-clicking always works from the last item that was clicked or ctrl-clicked.  If the last was
	// unselected it works from the one before that, etc.  Using a set so they can be pulled out if
	// unselected, but Javascript sets maintain their order, so we can still grab the latest.
	singleSelectionHistory:Set<number> = new Set<number>();

	// If we shift-click a second time, the previous one is undone, so remember it.
	shiftSelectMappings:number[] = [];

	visibleMappings:ProductMappingTableEntry[] = [];

	showFilter: boolean = false;

	tableFilter:TableFilter = {
	  accountTypes: [],
	  kasasaPowered: KasasaPoweredState.BOTH,
	}

	uploadFile:File|null = null;

	productMappingErrorMessage!: string | null;

	@Mutation('productMappingErrorMessage') mutationProductMappingErrorMessage: any;

	// Make enum visible to template
	KasasaPoweredState: any = KasasaPoweredState;

	mounted() {
	  this.loadData();
	}

  	@Watch('fiId')
	loadData() {
	  this.loading++;

	  this.productTypesResource.get().then((productTypes:ProductTypeMap) => {
		  this.productTypes = productTypes;
		  this.loadMappings();
		  this.loadAccountTypeMappings();
		  this.loadAccountProductTypeMappings();
	  }).catch((error:any) => {
	    this.showError(error);
	  }).finally(() => {
		  this.loading--;
	  });
	}

  	async loadMappings() {
  	  this.loading++;
  	  this.productMappingResource.get(this.fiId).then((results:ProductMapping[]) => {
  	    this.allProductMappings = [];
  	    results.forEach((mapping:ProductMapping) => {
  	      this.allProductMappings.push({
  	        mapping,
  	        selected: false,
  	      });
  	    });
  	    this.filteredProductMappings = [...this.allProductMappings];
  	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
  	    this.loading--;
  	  });
  	}

  	async loadAccountTypeMappings() {
	  this.loading++;
  	  this.coreAccountTypeMap.clear();
  	  this.accountTypeMappingRuleResource.getAll(this.fiId.toString()).then((results:AccountTypeMappingRule[]) => {
  	    results.forEach((accountType:AccountTypeMappingRule) => {
  	      this.coreAccountTypeMap.set(accountType.kasasaAccountType, accountType.coreAccountTypes);
  	    });
  	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.loading--;
  	  });
  	}

  	async loadAccountProductTypeMappings() {
	  this.loading++;
  	  this.accounProductTypesResource.get().then((results:AccountProductTypeMap) => {
  	    this.accountProductTypeMap = results;
  	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.loading--;
  	  });
  	}

	getRowClassForItem = (item:ProductMappingTableEntry) : string => (item.selected ? 'selectedRow' : '')

	getFriendlyProductTypeName(productType:string) : string {
	  if (this.productTypes && this.productTypes[productType]) {
	    return this.productTypes[productType].displayName;
	  }
	  return productType;
	}

	getLastQueryCount = (entry: ProductMappingTableEntry) : number => {
	  let total = 0;
	  entry.mapping.coreAccountProductTypes.forEach((product:CoreAccountProduct) => {
		  if (product.lastQueryCount) {
			  total += product.lastQueryCount;
		  }
	  });
	  return total;
	}

	applyFilter() {
	  this.deselectAllMappings();
	  this.filteredProductMappings = this.allProductMappings.filter((value:ProductMappingTableEntry) => {
	    if (this.tableFilter.accountTypes.length > 0 && !this.tableFilter.accountTypes.includes(value.mapping.accountType!)) {
	      return false;
	    }

	    if (this.tableFilter.kasasaPowered === KasasaPoweredState.YES) {
	      return value.mapping.kasasaPowered;
	    }

	    if (this.tableFilter.kasasaPowered === KasasaPoweredState.NO) {
	      return !value.mapping.kasasaPowered;
	    }

	    return true;
	  });
	}

	clearFilter() {
	  this.tableFilter = {
	    accountTypes: [],
	    kasasaPowered: KasasaPoweredState.BOTH,
	  };
	  this.applyFilter();
	}

	@Watch('showFilter')
	onFilterToggle() {
	  if (!this.showFilter) {
	    this.clearFilter();
	  }
	}

	onVisibleItemsChanged(items:ProductMappingTableEntry[]) {
	  this.deselectAllMappings();
	  this.visibleMappings = items;
	}

	rowClick(entry:ProductMappingTableEntry, index:number) {
	  this.deselectAllMappings();
	  this.shiftSelectMappings = [];
	  this.selectMapping(entry);
	  this.singleSelectionHistory.add(index);
	}

	ctrlClick(mapping:ProductMappingTableEntry, index:number) {
	  this.shiftSelectMappings = [];
	  if (!this.selectedMappings.has(mapping)) {
	    this.selectMapping(mapping);
	    this.singleSelectionHistory.add(index);
	  } else {
	    this.deselectMapping(mapping, index);
	  }
	}

	shiftClick(mapping:ProductMappingTableEntry, index:number) {
	  this.shiftSelectMappings.forEach(deselectIndex => this.deselectMapping(this.visibleMappings[deselectIndex], deselectIndex));
	  this.shiftSelectMappings = [];

	  let startIndex:number = -1;
	  if (this.singleSelectionHistory.size > 0) {
	    startIndex = Array.from(this.singleSelectionHistory).pop() as number;
	  }

	  let step:number = 1;
	  if (startIndex > index) {
	    step = -1;
	  }

	  for (let i:number = (startIndex + step); i !== (index + step); i += step) {
	    this.selectMapping(this.visibleMappings[i]);
	    this.shiftSelectMappings.push(i);
	  }
	}

	selectMapping(mapping:ProductMappingTableEntry) {
	  /* eslint-disable no-param-reassign */
	  mapping.selected = true;
	  /* eslint-enable no-param-reassign */

	  this.selectedMappings.add(mapping);
	}

	deselectMapping(mapping:ProductMappingTableEntry, index:number) {
	  /* eslint-disable no-param-reassign */
	  mapping.selected = false;
	  /* eslint-enable no-param-reassign */

	  this.selectedMappings.delete(mapping);
	  this.singleSelectionHistory.delete(index);
	}

	deselectAllMappings() {
	  this.selectedMappings.clear();
	  this.singleSelectionHistory.clear();
	  this.shiftSelectMappings = [];

	  this.filteredProductMappings.forEach((mapping:ProductMappingTableEntry) => {
		  /* eslint-disable no-param-reassign */
		  mapping.selected = false;
		  /* eslint-enable no-param-reassign */
	  });
	}

	onDeleteSingleMapping(entry:ProductMappingTableEntry) {
	  const that = this;
	  const dialog = new
	  Dialog('Confirm Deletion', 'Are you sure you want to delete this product mapping?');
	  dialog.setAcceptLabel('OK')
	    .setDeclineLabel('Cancel');
	  this.$store.dispatch('notices/add', dialog)
	    .then((ok) => {
	      if (ok === 'accept') {
	        that.productMappingResource.remove(that.fiId, entry.mapping.id as number).then((result:AxiosResponse) => {
	          that.removeMappingFromList(entry.mapping.id!);
	          that.selectedMappings.delete(entry);
	        });
	      }
	    });
	}

	onDeleteSelectedMappings() {
	  const idsWithAssociatedAccounts:number[] = this.getSelectedMappingsIdsWithAssociatedAccounts();

	  if (idsWithAssociatedAccounts.length > 0) {
	    let ids:string = '';
	    for (let i = 0; i < idsWithAssociatedAccounts.length; i++) {
	      ids += idsWithAssociatedAccounts[i];
	      if (i < idsWithAssociatedAccounts.length - 1) {
	        ids += ', ';
	      }
	    }

	    this.setError(`You cannot multi-delete product mappings if any have associated accounts. Please un-select product mappings that have associated accounts (ID: ${ids}) and try again.`);
	  } else {
	  const that = this;
	  const dialog = new Dialog('Confirm Deletion', 'Are you sure you want to delete these '
			+ `${this.selectedMappings.size} product mappings?`);
	  dialog.setAcceptLabel('OK')
	    .setDeclineLabel('Cancel');
	  this.$store.dispatch('notices/add', dialog)
	    .then((ok) => {
	      if (ok === 'accept') {
	        that.deleteSelectedMappings();
	      }
	    });
	  }
	}

	async deleteSelectedMappings():Promise<void> {
	  const toDeleteArray:ProductMappingTableEntry[] = [...this.selectedMappings];
	  const results:Promise<AxiosResponse<any>>[] = [];
	  	for (let i:number = 0; i < toDeleteArray.length; i++) {
	    results.push(this.productMappingResource.remove(this.fiId, toDeleteArray[i].mapping.id as number));
	    	this.removeMappingFromList(toDeleteArray[i].mapping.id!);
	    	this.selectedMappings.delete(toDeleteArray[i]);
	  	}
	  await Promise.all(results);
	}

	removeMappingFromList(id:number) {
	  for (let i:number = 0; i < this.allProductMappings.length; i++) {
	    if (this.allProductMappings[i].mapping.id === id) {
	      this.allProductMappings.splice(i, 1);
	      break;
	    }
	  }

	  for (let i:number = 0; i < this.filteredProductMappings.length; i++) {
	    if (this.filteredProductMappings[i].mapping.id === id) {
	      this.filteredProductMappings.splice(i, 1);
	      break;
	    }
	  }
	}

	onMergeSelectedMappings() {
	  const idsWithAssociatedAccounts:number[] = this.getSelectedMappingsIdsWithAssociatedAccounts();

	  if (idsWithAssociatedAccounts.length > 0) {
	    let ids:string = '';
	    for (let i = 0; i < idsWithAssociatedAccounts.length; i++) {
	      ids += idsWithAssociatedAccounts[i];
	      if (i < idsWithAssociatedAccounts.length - 1) {
	        ids += ', ';
	      }
	    }

	    this.setError(`You cannot merge product mappings if any have associated accounts. Please un-select product mappings that have associated accounts (ID: ${ids}) and try again.`);
	  } else {
	    const mappingIds:number[] = [];
	    this.selectedMappings.forEach((entry:ProductMappingTableEntry) => {
	      mappingIds.push(entry.mapping.id!);
	    });
	    this.productMappingResource.mergeMappings(this.fiId, mappingIds).then((result:AxiosResponse) => {
	      this.loadData();
	    })
	      .catch((error:any) => {
	        this.showError(error);
	      });
	  }
	}

	getSelectedMappingsIdsWithAssociatedAccounts() : number[] {
	  const ids:number[] = [];

	  this.selectedMappings.forEach((entry:ProductMappingTableEntry) => {
		  if (entry.mapping.hasAssociatedAccounts) {
			  ids.push(entry.mapping.id!);
		  }
	  });
	  return ids;
	}

	onMappingSaved(savedMapping:ProductMapping) {
	  let found:boolean = false;
	  for (let i:number = 0; i < this.allProductMappings.length; i++) {
	    if (this.allProductMappings[i].mapping.id === savedMapping.id) {
	      // Saved an existing mapping, so make sure that it is up to date.
	      Object.assign(this.allProductMappings[i].mapping, savedMapping);
	      found = true;
	      break;
	    }
	  }

	  if (!found) {
	    this.allProductMappings.push({
	      mapping: savedMapping,
		  selected: false,
	    });
	    this.applyFilter();
	  }
	}

	exportProductMappings() {
	  this.exporting = true;
	  this.productMappingResource.export(this.fiId).then((content:Blob) => {
	    const anchor = document.createElement('a');
	  	anchor.href = URL.createObjectURL(content);
	  	anchor.download = `${this.fiId}_product_mapping_export.xlsx`;
	  	anchor.click();
	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.exporting = false;
  	  });
	}

	onFileChanged(e:Event) {
	  const target:any = e.target;
	  this.uploadFile = target.files[0];

	  if (this.uploadFile) {
	    const that = this;

	    const dialog = new Dialog('Confirm Upload', `Are you sure you want to upload product mappings from ${this.uploadFile!.name}?`);
	    dialog.setAcceptLabel('OK')
	      .setDeclineLabel('Cancel');
	    this.$store.dispatch('notices/add', dialog)
	      .then((ok) => {
	        if (ok === 'accept') {
	          that.uploadMappings();
	        }
	      });
	  }
	}

	uploadMappings() {
	  this.uploading = true;
	  this.mutationProductMappingErrorMessage(null);
	  this.productMappingResource.upload(this.fiId, this.uploadFile!).then((result:VerificationResponse) => {
	    if (!result.error) {
	      	this.setSuccess(result.message);
	    	this.loadData();
	  		this.mutationProductMappingErrorMessage(null);
	    } else {
	      	this.mutationProductMappingErrorMessage(result.message);
	    }
	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.uploading = false;
  	  });
	}

	verify() {
	  this.mutationProductMappingErrorMessage(null);
	  this.verifying = true;
	  this.productMappingResource.verify(this.fiId).then((result:VerificationResponse) => {
	    if (!result.error) {
	      	this.setSuccess(result.message);
	    } else {
	  		this.mutationProductMappingErrorMessage(result.message);
	    }
	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.verifying = false;
  	  });
	}

	downloadErrorReport() {
	  this.downloadingErrorReport = true;
	  this.productMappingResource.downloadErrorReport(this.fiId).then((content:Blob) => {
	    const anchor = document.createElement('a');
	  	anchor.href = URL.createObjectURL(content);
	  	anchor.download = 'product_mapping_error_report.xls';
	  	anchor.click();
	  }).catch((error:any) => {
  	    this.showError(error);
  	  }).finally(() => {
	    this.downloadingErrorReport = false;
  	  });
	}

	showError(error: any) {
	  console.error(error);
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.setError(error.response.data.entity);
	  } else {
	    this.setError('An unexpected error occurred.');
	  }
	}

	setError(message: string) {
	  const al = new Alert(message, NoticeClass.ERROR);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}

	setSuccess(message: string) {
	  const al = new Alert(message, NoticeClass.SUCCESS);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}
}
</script>

<style lang="scss" scoped>
tbody tr:nth-of-type(odd) {
   background-color: rgba(31, 25, 25, 0.02);
   background-blend-mode: multiply;
 }

 td {
	 user-select:none;	// So that shift-clicking doesn't highlight text
 }

 .selectedRow {
    background: #c7c7c7 !important;
	  background-blend-mode: multiply;
  }
</style>
